import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {metadata, renderHead} from './metadata';
export default function PageMetadata() {
  const {pathname} = useLocation();
  useEffect(() => {
    document.querySelectorAll('[data-hk-seo], meta[name="robots"]').forEach(node => node.remove());
    const template = document.createElement('template');
    template.innerHTML = renderHead(pathname, process.env.REACT_APP_APP_ENV || 'local');
    template.content.querySelector('title')?.remove();
    document.title = metadata(pathname).title;
    document.head.append(template.content);
  }, [pathname]);
  return null;
}
